export class ListDetail {
    Id: number;
    Title: string;
    ForeignTitle: string;
    ResultListId: number;
    NormalRangeType: number;
}
